import {useCallback, useMemo, useState} from "react";
import {
	SelectUserAll,
	SelectCustomerAll,
	SelectField,
	DateField
} from "~/components/Forms";
import {StatusLabel} from "~/components";
import {useCan, useUtilities} from "~/hooks";
import {strToTime} from "../../../../utils";

function DebtSearchBar({filter, listGroup, onChange}) {

	const {utilities} = useUtilities();

	const can = {
		listAll: useCan('contractListAll'),
		listGroup: useCan('contractListGroup'),
		add: useCan('contractAdd'),
		edit: useCan('contractEdit'),
		transfer: useCan('contractTransfer'),
		delete: useCan('contractDelete'),
	};

	const [optionsUser, setOptionsUser] = useState([{value:'', label:'Tất cả'}]);

	const serviceOptions = useMemo(() => {
		return [{ value: '', label: 'Tất cả' }, ...Object.entries(utilities.services).map(([key, value]) => {
			return {
				value: key,
				label: <StatusLabel small type={value.color}>{value.label}</StatusLabel>
			};
		})];
	}, [utilities.services]);

	const groupOptions = useMemo(() => {
		return [{ value: '', label: 'Tất các nhóm' }, ...Object.entries(listGroup).map(([key, group]) => {
			return {
				value: group.id,
				label: group.name
			};
		})];
	}, [listGroup]);

	const handleUserChange = useCallback((value) => {
		if(onChange) onChange('userId', value);
	}, [onChange]);

	const handleCustomerChange = useCallback((value) => {
		if(onChange) onChange('customerId', value);
	}, [onChange]);

	const handleServiceChange = useCallback((value) => {
		if(onChange) onChange('service', value);
	}, [onChange]);

	const handleGroupChange = useCallback((value) => {
		if(onChange) onChange('groupId', value);
	}, [onChange]);

	const handleTimeChange = useCallback((value) => {
		value = strToTime(value);
		if(onChange) onChange('signing', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					{(can.listAll) && <DateField value={filter.time} name="signing" placeholder="Tháng ký" picker="month" onChange={handleTimeChange}/>}
					<SelectCustomerAll defaultValue={filter.customerId} value={filter.customerId} placeholder="Khách hàng" options={[{value:'', label:'Tất cả'}]} onChange={handleCustomerChange} />
					{(can.listAll || can.listGroup) && <SelectField placeholder="Chọn nhóm" options={groupOptions} onChange={(value, event) => handleGroupChange(value)} />}
					{(can.listAll || can.listGroup) && <SelectUserAll value={filter.userId} placeholder="Nhân viên" options={optionsUser} setOptions={setOptionsUser} onChange={handleUserChange} />}
					<SelectField value={filter.service} placeholder="Dịch vụ" options={serviceOptions} onChange={handleServiceChange}/>
				</form>
			</div>
		</div>
	)
}

export default DebtSearchBar;